export default "__VITE_ASSET__DJr8GkzS__"